import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { UtilsFbPixelInitialise } from '@vc-workspace/utils-fb-pixel';
import Head from 'next/head';
import { getPixelIdsForInitialisation } from '../utilities/utilities';

var BasicSEO = function BasicSEO(props) {
  return /*#__PURE__*/_jsxs(Head, {
    children: [/*#__PURE__*/_jsx("title", {
      children: props.title
    }), props.description ? /*#__PURE__*/_jsx("meta", {
      name: "description",
      content: props.description
    }) : null, props.keywords ? /*#__PURE__*/_jsx("meta", {
      name: "keywords",
      content: props.keywords
    }) : null, /*#__PURE__*/_jsx(UtilsFbPixelInitialise, {
      fbPixelIds: getPixelIdsForInitialisation(props.shopId ? [props.shopId] : null)
    })]
  });
};

export default BasicSEO;